"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuidv4 = require("uuid/v4");
const __1 = require("..");
const helpers_1 = require("../helpers");
class Command {
    constructor(receiver) {
        this.objectUuid = uuidv4();
        if (Command.isClass(receiver)) {
            this.typeClass = receiver;
        }
        else {
            if (!receiver.getPermissions().includes(__1.Permission.execute)) {
                throw new Error("No execute permission on current object");
            }
            this.typeClass = receiver.constructor;
            this.receiver = new __1.OMReference(receiver.constructor, receiver);
        }
    }
    get id() { return this.objectUuid; }
    get objectType() { return __1.OMUniverse.shared.objectType(this); }
    // tslint:disable-next-line
    static isClass(x) {
        return x.constructor === Function;
    }
    execute() {
        const url = (() => {
            if (this.receiver) {
                return `${this.typeClass.Path}/${this.receiver.id}/${this.constructor.Path}`;
            }
            else {
                return `${this.typeClass.Path}/${this.constructor.Path}`;
            }
        })();
        return __1.OMUniverse.shared.apiClient.send({
            data: helpers_1.JsonUtils.toJsonApi(this),
            method: "POST",
            url,
        });
    }
}
Command.Type = "command";
Command.Path = "perform";
exports.default = Command;
//# sourceMappingURL=OMCommand.js.map